module.exports = __webpack_public_path__ + "media/images/checkout/Comodo-c09e94c583f1a715bed5cff77e95d331.png";